/**
 * @description
 */
export default function noNegative(value) {
    return 0 <= value || 'No se permiten números negativos.'
}
